import { Carousel, CarouselContent, CarouselItem } from '#/components/ui/carousel';
import { Link } from 'react-router';

import type { RecommendShopItemV2 } from '~/api/v2/mall/recommend-shop';
import { CampaignLogo, type CampaignLogoStyles } from '~/ui/campaign-logo';
import { tw, useMediaQuery } from '~/utils';

export const recommendShopLogoStyles = tw<CampaignLogoStyles>({
  box: {
    shop: 'max-h-[96px] max-w-[96px] md:max-h-[120px] md:max-w-[120px]',
    offer: '',
  },
  img: '',
});

export const SiteRecommendShopLogo = ({ recommendShopDetail }: { recommendShopDetail: RecommendShopItemV2[] }) => {
  const isLarge = useMediaQuery('(min-width: 1152px)');

  const RecommendShop = isLarge ? 'div' : Carousel;
  const RecommendShopContent = isLarge ? 'div' : CarouselContent;
  const RecommendShopItem = isLarge ? 'div' : CarouselItem;
  const RecommendShopProps = isLarge
    ? {}
    : {
        opts: {
          align: 'start' as const,
          loop: false,
          dragFree: true,
        },
      };

  return (
    <RecommendShop {...RecommendShopProps}>
      <RecommendShopContent className="mr-2 ml-4 lg:flex lg:flex-wrap lg:justify-center lg:gap-2.5">
        {recommendShopDetail.map((shop) => {
          return (
            <RecommendShopItem
              key={shop.campaign_id}
              className="max-w-[96px] pr-2 pl-0 md:mr-[10px] md:max-w-[120px] md:pr-0 lg:mr-0">
              <Link to={`/shop/${shop.campaign_id}`}>
                <CampaignLogo data={shop} styles={recommendShopLogoStyles} />
              </Link>
            </RecommendShopItem>
          );
        })}
      </RecommendShopContent>
    </RecommendShop>
  );
};
